import { render, staticRenderFns } from "./SettingsStageBestOfLower.vue?vue&type=template&id=a90b567c&"
import script from "./SettingsStageBestOfLower.vue?vue&type=script&lang=js&"
export * from "./SettingsStageBestOfLower.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports